export default function ProfileSubscriptionsController(
  $scope,
  $rootScope,
  usersService,
  gettextCatalog,
) {
  'ngInject';

  $scope.currentStatus = null;
  $scope.agreement;

  function getUserInfo() {
    $scope.userme = $rootScope.currentUser;
    try {
      $scope.currentStatus = $scope.userme.claims.data.emailNotification
        ? 'Subscribe'
        : 'Unsubscribe';
    } catch (e) {
      $scope.currentStatus = 'Unsubscribe';
    }
  }

  // to get user information
  getUserInfo();

  $scope.addRemoveEmailSubscribtion = function () {
    var chageset = {};
    $scope.resetFlags();

    if ($scope.currentStatus == 'Unsubscribe' && $scope.agreement) {
      chageset = {
        op: 'add',
        claims: {
          emailNotification: true,
        },
      };
    } else if ($scope.currentStatus == 'Subscribe' && !$scope.agreement) {
      chageset = {
        op: 'remove',
        claims: {
          emailNotification: true,
        },
      };
    } else {
      return;
    }

    $scope.sending = true;
    usersService
      .patchCurrentUserClaims([chageset])
      .then(
        function (result) {
          //get updated info
          if (result.data) {
            $scope.userme.claims.data.emailNotification = result.data.hasOwnProperty(
              'emailNotification',
            );
            $scope.currentStatus = $scope.userme.claims.data.emailNotification
              ? 'Subscribe'
              : 'Unsubscribe';
          }
          $scope.SuccessFlag = true;
        },
        function (error) {
          var errorMsg = gettextCatalog.getString(
            'An error occurred while updating your subscription',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorFlag = true;
          $scope.errorText = errorMsg;
        },
      )
      .finally(function () {
        $scope.sending = false;
      });
  };

  $scope.resetFlags = function () {
    $scope.errorFlag = false;
    $scope.SuccessFlag = false;
  };

  $scope.$watch('currentStatus', function () {
    if ($scope.currentStatus == 'Subscribe') {
      $scope.agreement = true;
    } else {
      $scope.agreement = false;
    }
  });
}
